<template>
  <div class="quiz-answer-row d-flex align-start">
    <div class="quiz-answer-row__buttons d-flex align-center pt-2 mr-2">
      <Icon icon="mdi-drag" class="answer-handle cursor-grab" color="darkGrey" />

      <div v-if="showCorrectness" class="d-flex align-center ml-2">
        <v-checkbox
          :input-value="answer.correctness"
          color="brandPrimary"
          class="pa-0 ma-0"
          hide-details
          :false-value="0"
          :true-value="1"
          @change="$emit('update:correctness', $event)"
        />
      </div>
    </div>

    <v-text-field
      :value="answer.content"
      outlined
      dense
      :label="isRequired ? 'Answer*' : 'Answer'"
      color="brandPrimary"
      hide-details="auto"
      :rules="[
        (v) => !!v || 'An answer is required',
        (v) => !v || v.length <= 255 || 'Answer must be 255 characters or fewer',
      ]"
      @input="$emit('update:content', $event)"
    />

    <Button v-if="showDeleteButton" icon small class="mt-1 ml-2" @click="$emit('delete')">
      <Icon icon="mdi-delete" color="darkGrey" />
    </Button>
  </div>
</template>

<script>
import Icon from "@/components/generic/Icon.vue";
import Button from "@/components/generic/Button.vue";

export default {
  components: {
    Icon,
    Button,
  },
  name: "QuizAnswerRow",
  props: {
    answer: {
      type: Object,
      required: true,
    },
    showCorrectness: {
      type: Boolean,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      default: true,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:content", "update:correctness", "delete"],
};
</script>

<style scoped>
.quiz-answer-row {
  min-height: 48px;
}
</style>
